import styled from "styled-components";
import Logo from "../logos/Logo";

const HeaderWrapper = styled.footer`
    width: 100%;
    padding: 1em;
    background-color: var(--primary-color);
    color: var(--secondary-color);
    border-top: 1px solid var(--primary-color);
    height: 3em;
    position: absolute;
    top: 0;
    font-size: 0.8em;
    display: flex;
    align-items: center;
`;

const LogoWrapper = styled.div`
    width: 10em;
`

const Header = () => {
    return(
        <HeaderWrapper>
            <LogoWrapper>
                <Logo src="../TroisPrimeLogo.png"></Logo>
            </LogoWrapper>
        </HeaderWrapper>
    )
}

export default Header;